export const setAffectationRegFrs = (value) => {
  return (dispatch) => {
    dispatch({ type: "AFF_REG_FRS", payload: value });
  };
};
